import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderImportInput } from './GetOrderImportInput';
import { GetOrderImportOutput } from './GetOrderImportOutput';

export class GetOrderImportService extends HttpServiceBase {

    handle = (input: GetOrderImportInput): Promise<Result<GetOrderImportOutput>|null> => {
        const promise = this.http.get<Result<GetOrderImportOutput>>(`${this.baseUrlSislogApi}/v2/order-import/${input.orderImportId}`);
        return promise;
    }
}